module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro4-old.5db84285.mp3";